<script>
import "leaflet/dist/leaflet.css";
import dayjs from 'dayjs'
import gql from 'graphql-tag';
import * as L from 'leaflet';
import 'leaflet.fullscreen';
import 'leaflet.fullscreen/Control.FullScreen.css';
import { mapState } from 'vuex';
import logoImg from '@/assets/logo2.png';

  export default {
    name: "mapa",
    components: {
      FilterMap: () => import('./FilterMap.vue')
    },

    data: () => ({
        center: [37,7749, -122,4194],
        filePath: '',
        layers: '',
        allLayers: '',
        mapa: '',
        layer: '',
        info: '',
        geoJson: '',
        legend: '',
        farmID: '',
        modules: ['Todos'],
        showPrint: true,
        limitDate: '',
        measureDate: '',
        sentinelHubLayer: '',
        imageFilter: 'NATURAL-COLOR',
        type: '',
        gain: 1.8,
        gama: 1.2,
        currentLabelVisibility: true,
        lastZoom: 15,
        tooltipThreshold: 15,
        rangeMS: [],
        rangeFDN: [],
        rangePB: [],
        rangeEM: [],
        rangeNDT: [],
        changingFarm: false,
        moduleCodes: {},
        date: null,
        oldDate: null,
        loaded: true,
        loadProgress: 0,
        delayValue : 10000,
    }),

    computed: {
      ...mapState('dashboard', ['filter']),
    },

    watch:{
      imediate: true,
      async filter() {
        if (this.farmID && this.filter.farmId && this.farmID !== this.filter.farmId) {
          this.delayValue = 10000
          if(this.geoJson){
            this.mapa.removeLayer(this.geoJson)
            this.geoJson = null
          }
          this.changingFarm = true
          await this.changeFarm()
          this.changingFarm = false
        }
        if (this.filter.date && this.filter.date !== this.date) {
          this.date = this.filter.date
        }
        if (this.filter.date && this.filter.date !== this.oldDate && !this.changingFarm) {
          this.oldDate = this.filter.date
          console.log('this.oldDate : ', typeof this.oldDate)
          if((typeof this.oldDate) === 'string' && this.oldDate.includes('.')) {
            this.oldDate = dayjs(this.oldDate).format('DD-MM-YYYY')
          }
          this.date = this.filter.date
          let date = dayjs(this.date)
          let limitDate = dayjs(date).subtract(6,'month').format('YYYY-MM-DD')
          this.limitDate = limitDate
          let measureDate = dayjs(date).format('YYYY-MM-DD')
          this.measureDate = measureDate
          await this.changeMeasureData()
          await this.changeMapDate()
        }
        if (this.imageFilter !== this.filter.imageFilter) {
          this.delayValue = 10000
          this.imageFilter = this.filter.imageFilter
          this.gain = this.filter.gain
          this.gama = this.filter.gama
          await this.changeMapFilter()
        } else if (this.gain !== this.filter.gain) {
          this.gain = this.filter.gain
          await this.changeMapGain()
        } else if (this.gama !== this.filter.gama) {
          this.gama = this.filter.gama
          await this.changeMapGama()
        }
        if (this.filter.type && this.date) {
          this.type = this.filter.type
          if (this.layers) {
            await this.showMeasureInfo()
          }
        }
        if (this.filter.modulesIds && this.modules && this.modules !== this.filter.modulesIds ) {
          this.modules = this.filter.modulesIds
          await this.changeLayer()
          await this.showMeasureInfo()
        }
        if (this.filter.label !== this.currentLabelVisibility) {
          await this.alterLabelVisibility()
          this.currentLabelVisibility = !this.currentLabelVisibility
        }
      }
    },

    mounted() {
        this.setupLeafletMap();
    },

    methods: {
      setupLeafletMap: async function () {
        var geoJson
        this.mapa = L.map('mapa', {
          minZoom: 12,
          zoomSnap: 0.1,
          zoomDelta: 0.1,
          scrollWheelZoom: true,
          wheelPxPerZoomLevel: 400,
          zoomControl: false,
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: 'topright',
          }
        }).setView([0, 0], 15);
        var mapa = this.mapa
        var legend = L.control({position: 'bottomleft'});
        this.legend = legend
        var info = L.control({position: 'bottomleft'});
        this.info = info
        let farmID = localStorage.getItem('lastFarm')
        this.farmID = farmID
        
        const geoData = await this.$apollo.query({
          query: gql`
            query farm_map_data($farm_id: uuid! ) {
              farm_map_data(
                where: {  
                  farm_id: {_eq: $farm_id},
                  deleted_at: {_is_null: true}
                }, order_by: { created_at: desc },
                   limit: 1,
              ) {
                geo_data
                }
            }
          `,
          variables: {
            farm_id: farmID,
          },
          fetchPolicy: 'no-cache',
        });

        const farmModules = await this.$apollo.query({
          query: gql`
            query modules($farm_id: uuid! ) {
              modules(
                where: {  
                  farm_id: {_eq: $farm_id}
                }, order_by: { created_at: desc },
              ) {
                id,
                name,
                code,
                module_color
                }
            }
          `,
          variables: {
            farm_id: farmID,
          },
          fetchPolicy: 'no-cache',
        });
        let paddocksArray = []
        let paddocksArea = {}
        if(farmModules && farmModules.data && farmModules.data.modules) {
          let modules = farmModules.data.modules
          for(let index = 0; index < modules.length; index++) {
            let moduleID = modules[index].id
            if (modules[index].module_color) {
              this.moduleCodes[modules[index].code] = modules[index].module_color
            } else {
              let h
              if (index % 2 === 0) {
                h = 300
              } else {
                h = 240
              }
              let s = Math.floor(Math.random() * 100);
              let l = Math.floor(Math.random() * 100);
              if (l < 30) {
                l = 30
              }
              let color = 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
              this.moduleCodes[modules[index].code] = color
            }
            let paddockArea = await this.$apollo.query({
              query: gql`
                query paddocks($module_id: uuid! ) {
                  paddocks(
                    where: {  
                      module_id: {_eq: $module_id}
                    }, order_by: { created_at: asc },
                  ) {
                    id,
                    name,
                    area,
                    code
                    }
                }
              `,
              variables: {
                module_id: moduleID,
              },
              fetchPolicy: 'no-cache',
            });
            if (paddockArea && paddockArea.data && paddockArea.data.paddocks) {
              paddocksArray = [...paddocksArray, ...paddockArea.data.paddocks]
            }
          }
          for(let index = 0; index < paddocksArray.length; index++) {
            let paddock = paddocksArray[index]
            paddocksArea[paddock.code] = paddock
          }
        }
        var colors = this.moduleCodes
        var infoUpdate = true
        function highlightFeature(e) {
          var layer = e.target;
          let code = layer.feature.properties.Name.split('_')
          layer.setStyle({
            weight: 5,
            color: colors[code[0]],
            dashArray: '',
            fillOpacity: 0.7
          });
          if (infoUpdate) {
            info.update(layer.feature.properties);
          }
          layer.bringToFront();
         }
         function resetHighlight(e) {
          geoJson.resetStyle(e.target);
          if (infoUpdate) {
            info.update();
          }
        }
        function lockInfo(e) {
          infoUpdate = false
          var layer = e.target;
          // mapa.fitBounds(e.target.getBounds());
          info.update(layer.feature.properties);
        }
        function onEachFeature(feature, layer) {
          layer.on({
              mouseover: highlightFeature,
              mouseout: resetHighlight,
              click: lockInfo
          });
        }
        function style(layer) {
          let code = layer.properties.Name.split('_')
          let styleInfo = {
              fillColor:  colors[code[0]] || '#FFEDA0',
              weight: 2,
              opacity: 1,
              color: colors[code[0]],
              fillOpacity: 0
          };
          if (layer.properties && layer.properties.area ) {
            if (layer.properties.area < 5) {
              styleInfo.weight = 1
            } else if (layer.properties.area > 15) {
              styleInfo.weight = 3
            }
          }
          return styleInfo
        }

        info.onAdd = function () {
            this._div = L.DomUtil.create('div', 'info'); // create a div with a class "info"
            L.DomUtil.addClass(this._div, 'info')
            this.update();
            return this._div;
        };

        // method that we will use to update the control based on feature properties passed
        info.update = function (props) {
          this._div.innerHTML = (props?
            '<b>Piquete: </b> '+ props.Name +'<br />'+' <b> Área: </b>'+ (props.area? props.area.toLocaleString() + ' ha': '') + '<br/>'
            + ( props.visibleMS? '<b> Matéria Seca no Piquete : </b> ' + props.visibleMS.toLocaleString() + ' kg' + '<br/>' : '') 
            + (props.ms? '<b> Matéria Seca por área : </b> ' +  props.ms.toLocaleString() + ' kg/ha' +'<br/>'  : '') 
            + (props.pb? '<b> Proteína : </b> ' + props.pb.toLocaleString() + '%' +'<br/>' : '') 
            + (props.fdn? '<b> Fibra : </b> ' +  props.fdn.toLocaleString() + '%' + '<br/>' : '') 
            + (props.em? '<b> Energia : </b> ' +  props.em.toLocaleString() + ' kcal/kg' + '<br/>' : '')
            + (props.ndt? '<b> NDT : </b> ' +  props.ndt.toLocaleString() + '%' + '<br/>' : '') 
            : '-');
        };


        info.addTo(mapa);
        mapa.on('enterFullscreen', () => {
          this.showPrint = false;
        });

        mapa.on('exitFullscreen', () => {
          this.showPrint = true;
        });
        let date = dayjs(new Date())
        let limitDate = dayjs(date).subtract(6,'month').format('YYYY-MM-DD')
        this.limitDate = limitDate
        let measureDate = dayjs(date).format('YYYY-MM-DD')
        this.measureDate = measureDate
        let baseUrl = "https://services.sentinel-hub.com/ogc/wms/84623a0a-c9b3-4489-bda6-996e0ebeda71";
        let sentinelHub = L.tileLayer.wms(baseUrl, {
            tileSize: 512,
            attribution: '&copy; <a href="http://www.sentinel-hub.com/" target="_blank">Sentinel Hub</a>',
                    urlProcessingApi:"https://services.sentinel-hub.com/ogc/wms/1d4de4a3-2f50-493c-abd8-861dec3ae6b2",
                maxcc:100, 
                minZoom:12, 
                maxZoom:25,
                zoomSnap: 0.05,
                gain:1.8,
                gama:1.2,
                preset: "NATURAL-COLOR", 
                layers:"NATURAL-COLOR", 
                upsampling: 'BICUBIC',
                downsampling: 'BILINEAR',
                time: limitDate + '/'+ measureDate, 
        }).addTo(mapa);

        // Detectar erro no carregamento de tiles
        sentinelHub.on('tileerror', function () {
          // Aplicar fundo branco ao pane de tiles
          mapa.getContainer('').style.backgroundColor = '#ffffff';
        });
        this.sentinelHubLayer = sentinelHub
        let osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        })

        let baseMaps = {
          'OpenStreetMap': osm
        };
        let overlayMaps = {
          'Sentinel Hub WMS': sentinelHub
        }
        L.control.layers(baseMaps, overlayMaps).addTo(mapa);
        var logo = L.control({position: "topleft"});
          logo.onAdd = function () {
            const img = L.DomUtil.create('img', 'logo'); // cria o elemento div com classe 'img'
            img.src = logoImg; // Usa o caminho resolvido pelo Webpack
            img.className = 'logo';
            img.style.width = '20%';
            return img;
          };
          logo.addTo(mapa);
          L.control.zoom({
            position: 'topright'
          }).addTo(mapa);

        if (geoData && geoData.data && geoData.data.farm_map_data.length > 0) {
          this.layers = JSON.parse(geoData.data.farm_map_data[0].geo_data)
          this.allLayers = this.layers.features
          for (let index = 0; index< this.layers.features.length; index++) {
            let layer = this.layers.features[index].properties
            if (layer.name) {
              layer.Name = layer.name
            }
            if (paddocksArea[layer.Name] && layer.Name === paddocksArea[layer.Name].code) {
              this.layers.features[index].properties.area = paddocksArea[layer.Name].area
              this.layers.features[index].properties.id = paddocksArea[layer.Name].id
            }
          }
          geoJson = L.geoJson(this.layers, {
            style: style,
            onEachFeature: onEachFeature,
          }).addTo(this.mapa)
          this.geoJson = geoJson
          const group = L.geoJSON(this.layers)
          // bounds real da geometria
          const bounds = group.getBounds()

          // adiciona margem (20% maior, por exemplo)
          const paddedBounds = bounds.pad(0.2)

          // aplica limite de navegação
          this.mapa.setMaxBounds(paddedBounds)
          this.mapa.options.maxBoundsViscosity = 0.7

          // centraliza
          this.mapa.fitBounds(bounds)
          
          if (geoJson) {
            const visibleBounds = geoJson.getBounds();
            this.mapa.fitBounds(visibleBounds, { padding: [10, 10] }); // Ajusta a visão para incluir apenas as geometrias visíveis
          }
        }
        if (this.type && this.date) {
          if (this.type !== 'Imagem Satélite') {
            await this.changeMeasureData()
          }
          await this.showMeasureInfo()
        }
      },

      isMobile() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android|iphone|ipad|ipod|blackberry|windows phone|opera mini|iemobile|wpdesktop/i.test(userAgent.toLowerCase());
      },

      calcCenterPoint() {
        let centerPoint = []
          let minX = 0
          let maxX = 0
          let minY = 0
          let maxY = 0
          if (this.layers.length > 1) {
            let point = this.layers[0].features.geometry.coordinates[0][0]
            minX = point[0]
            maxX = point[0]
            minY = point[1]
            maxY = point[1]
            for (let index = 1; index < this.layers.length; index++) {
              point = this.layers[index].features.geometry.coordinates[0][0]
              if (minX > point[0]) {
                minX = point[0]
              }
              if(maxX < point[0]) {
                maxX = point[0]
              }
              if (minY > point[1]) {
                minY = point[1]
              }
              if(maxY < point[1]) {
                maxY = point[1]
              }
            }
            centerPoint.push(minX + ((maxX - minX)/2))
            centerPoint.push(minY + ((maxY - minY)/2))
          } else {
            let point = this.layers.features[0].geometry.coordinates[0][0]
            minX = point[0]
            maxX = point[0]
            minY = point[1]
            maxY = point[1]
            let layers = this.layers.features
            for (let index = 1; index < layers.length; index++) {
              point = layers[index].geometry.coordinates[0][0]
              if (minX > point[0]) {
                minX = point[0]
              }
              if(maxX < point[0]) {
                maxX = point[0]
              }
              if (minY > point[1]) {
                minY = point[1]
              }
              if(maxY < point[1]) {
                maxY = point[1]
              }
            }
            centerPoint.push(minX + ((maxX - minX)/2))
            centerPoint.push(minY + ((maxY - minY)/2))
            centerPoint.push(minX)
            centerPoint.push(maxX)
            centerPoint.push(minY)
            centerPoint.push(maxY)
          }
          return centerPoint
      },

      async showMeasureInfo() {
        var mapa = this.mapa
        let labelVisibility = this.currentLabelVisibility
        var geoJson = this.geoJson
        var info = this.info
        var legend = this.legend
        var type = this.type
        var filterType = this.imageFilter
        var colors = this.moduleCodes
        var module = this.modules
        if (this.type) {
          if (geoJson) { 
            mapa.removeLayer(geoJson)
          }
          info.remove(mapa)
          legend.remove(mapa)
        }
        var gradeModule = []
        if (!this.modules.includes('Todos')) {
          let valueDivided
          if(this.type === 'Matéria seca') {
            valueDivided = this.rangeMS[0] / 7
            gradeModule[0] = 0
            for (let index = 1; index < 6; index++) {
              gradeModule[index] = Math.round((valueDivided * index)/50)*50
            }
            gradeModule.push(Math.floor(this.rangeMS[0]/50)*50)
          } else if (this.type === 'Fibra') {
            if (this.rangeFDN[0] > 0) {
              valueDivided = (this.rangeFDN[0] - this.rangeFDN[1]) / 7
              gradeModule[0] = this.rangeFDN[1]
              for (let index = 1; index < 6; index++) {
                gradeModule[index] = parseFloat((valueDivided * index + this.rangeFDN[1]).toFixed(0))
              }
              gradeModule.push(this.rangeFDN[0])
            }
          } else if (this.type === 'Proteína') {
            if (this.rangePB[0] > 0) {
              valueDivided = (this.rangePB[0] - this.rangePB[1]) / 7
              gradeModule[0] = this.rangePB[1]
              for (let index = 1; index < 6; index++) {
                gradeModule[index] = parseFloat((valueDivided * index + this.rangePB[1]).toFixed(1))
              }
              gradeModule.push(this.rangePB[0])
            }
          }
          else if (this.type === 'Energia') {
            if (this.rangeEM[0] > 0) {
              valueDivided = (this.rangeEM[0] - this.rangeEM[1]) / 7
              gradeModule[0] = this.rangeEM[1]
              for (let index = 1; index < 6; index++) {
                gradeModule[index] = parseFloat((valueDivided * index + this.rangeEM[1]).toFixed(0))
              }
              gradeModule.push(this.rangeEM[0])
            }
          } else if (this.type === 'NDT') {
            gradeModule[0] = 0
            gradeModule[1] = 40
            gradeModule[2] = 45
            gradeModule[3] = 50
            gradeModule[4] = 55
            gradeModule[5] = 60
            gradeModule[6] = 65
          }
        }
        function getColor(value) {
            if(type === 'Matéria seca') {
              return value >= gradeModule[gradeModule.length-1] ? '#008000' :
                  value > gradeModule[gradeModule.length-2] ? '#71B200' :
                  value > gradeModule[gradeModule.length-3] ? '#4ced0c' :
                  value > gradeModule[gradeModule.length-4]  ? '#eded05' :
                  value > gradeModule[gradeModule.length-5] ? '#f58f14' :
                  value > gradeModule[gradeModule.length-6]  ? '#f51b1b' :
                  value > 0  ? '#8b0000' :
                              '#FFFFFF';
                              
            } else if (type === 'Fibra') {
              return value >= gradeModule[gradeModule.length-1] ? '#5c2002' :
                value > gradeModule[gradeModule.length-2] ? '#CC3300' :
                value > gradeModule[gradeModule.length-3] ? '#c4912b' :
                value > gradeModule[gradeModule.length-4] ? '#FFC000' :
                value > gradeModule[gradeModule.length-5] ? '#70AD47' :
                value > gradeModule[gradeModule.length-6] ? '#548235' :
                value > 0  ? '#333300' :
                            '#FFFFFF';
            } else if (type === 'Energia') {
              return value >= gradeModule[gradeModule.length-1] ? '#0000FF' :
                value > gradeModule[gradeModule.length-2]  ? '#5555AA' :
                value > gradeModule[gradeModule.length-3]  ? '#AAAA55' :
                value > gradeModule[gradeModule.length-4]  ? '#FFFF00' :
                value > gradeModule[gradeModule.length-5]  ? '#FFAA00' :
                value > gradeModule[gradeModule.length-6]  ? '#FF5500' :
                value > 0  ? '#FF0000' :
                            '#FFFFFF';
            } else if (type === 'Proteína') {
              return value >= gradeModule[gradeModule.length-1] ? '#003300' :
                value > gradeModule[gradeModule.length-2]  ? '#008000' :
                value > gradeModule[gradeModule.length-3]  ? '#2be80e' :
                value > gradeModule[gradeModule.length-4]  ? '#92D050' :
                value > gradeModule[gradeModule.length-5]  ? '#FFC000' :
                value > gradeModule[gradeModule.length-6]  ? '#BF9000' :
                value > 0  ? '#CC6600' :
                            '#FFFFFF';
            } else if (type === 'Imagem Satélite' && filterType === 'NDVI' ) {
              return value === 'sombra'? '#4C4C4C' :
                value === 'nuvem'? '#CCCCCC' :
                value === 'agua'? '#0000CC' :
                value >= 90 ? '#004D00' :  // Floresta muito densa
                value >= 80 ? '#0D660D' :  // Vegetação densa (alta)
                value >= 70 ? '#1A801A' :  // Vegetação muito densa
                value >= 60 ? '#339933' :  // Vegetação densa
                value >= 50 ? '#99CC4D' :  // Vegetação bem estabelecida
                value >= 40 ? '#D9B333' :  // Vegetação saudável
                value >= 30 ? '#EDBF1A' :  // Vegetação moderada
                value >= 20 ? '#FFD966' :  // Vegetação esparsa
                value >= 10 ? '#FFEB99' :  // Vegetação inicial
                value >= 1  ? '#FFFFFF' :  // Solo exposto (isso foi configurado como branco)
                                '#4D4D4D';   // Sombra de nuvem
            } else if  (type === 'Imagem Satélite' && filterType === 'MOISTURE-INDEX' ) {
              return value >= 0.8 ? '#006400' : // verde escuro
                value >= 0.5? '#3C7D22' : // verde médio
                value >= 0.24 ? '#92D050': // verde claro
                value >= 0.032 ? '#90ee90' : // verde claro intermediário
                value >=  0? '#ffff00' : // amarelo
                value >= -0.032? '#ffc000' : // amarelo-laranja
                value >= -0.24? '#ff0000' : // vermelho
                value <= -0.8? '#800000' : // marrom escuro
                              '#FFFFFF';
            } else if (type === 'NDT') {
              return value >= gradeModule[gradeModule.length-1] ? '#0000FF' :
                value > gradeModule[gradeModule.length-2]  ? '#5555AA' :
                value > gradeModule[gradeModule.length-3]  ? '#AAAA55' :
                value > gradeModule[gradeModule.length-4]  ? '#FFFF00' :
                value > gradeModule[gradeModule.length-5]  ? '#FFAA00' :
                value > gradeModule[gradeModule.length-6]  ? '#FF5500' :
                value > 0  ? '#FF0000' :
                            '#FFFFFF';
            } 
            else {
              return false
            }
        }
        function style(feature) {
          let value
          if(type === 'Matéria seca') {
            value = feature.properties.ms
          } else if (type === 'Fibra') {
            value = feature.properties.fdn  
          } else if (type === 'Energia') {
            value = feature.properties.em
          } else if (type === 'Proteína') {
            value = feature.properties.pb
          } else if (type === 'NDT') {
            value = feature.properties.ndt
          }
          let code = feature.properties.Name.split('_')
          let styleInfo = {
              fillColor: type !== 'Imagem Satélite'? (getColor(value) || colors[code[0]]) : '#FFFFFF',
              weight: 2,
              opacity: 1,
              color: colors[code[0]],
              fillOpacity: type !== 'Imagem Satélite'? 0.8 : 0
          };
          if (feature.properties && feature.properties.area ) {
            if (feature.properties.area < 5) {
              styleInfo.weight = 1
            } else if (feature.properties.area > 15) {
              styleInfo.weight = 3
            }
          }
          return styleInfo
        }
        if (this.type) {
          if (this.type !== 'Imagem Satélite') {
            info.onAdd = function () {
                this._div = L.DomUtil.create('div', 'info'); // create a div with a class "info"
                L.DomUtil.addClass(this._div, 'info')
                this.update();
                return this._div;
            };
            // method that we will use to update the control based on feature properties passed
            info.update = function (props) {
              this._div.innerHTML = (props?
                '<b>Piquete: </b> '+ props.Name +'<br />'+' <b> Área: </b>'+ (props.area? props.area.toLocaleString() + ' ha': '') + '<br/>'
                + ( props.visibleMS? '<b> Matéria Seca no Piquete : </b> ' + props.visibleMS.toLocaleString() + ' kg' + '<br/>' : '') 
                + (props.ms? '<b> Matéria Seca por área : </b> ' +  props.ms.toLocaleString() + ' kg/ha' +'<br/>'  : '') 
                + (props.pb? '<b> Proteína : </b> ' + props.pb.toLocaleString() + '%' +'<br/>' : '') 
                + (props.fdn? '<b> Fibra : </b> ' +  props.fdn.toLocaleString() + '%' + '<br/>' : '') 
                + (props.em? '<b> Energia : </b> ' +  props.em.toLocaleString() + ' kcal/kg' + '<br/>' : '')
                + (props.ndt? '<b> NDT : </b> ' +  props.ndt.toLocaleString() + '%' + '<br/>' : '')
                : '-');
            };
          }
          if (type !== ' ') {
            const layers = this.allLayers
            legend.onAdd = function () {
              var grades
              var gradesLabel = [
                'Muito bom',
                'Bom',
                'Regular',
                'Ruim ou seco',
                'Muito ruim',
                'Solo exposto',
                'Núvem',
                'Sombra',
                'Água',
              ]
              if (filterType === 'MOISTURE-INDEX') {
                gradesLabel = [
                  '< 20% (Tenro)',
                  '20 a 30%',
                  '30 a 40%',
                  '40 a 50%',
                  '50 a 60%',
                  '60 a 70%',
                  '70 a 80%',
                  '> 80% (Seco)'
                ]
              }
              if (module.includes('Todos')) {
                if(type === 'Matéria seca') {
                  let greaterMs = 0
                  let lesserMs = null
                  for (let index = 0; index < layers.length; index++ ) {
                    let layer = layers[index]
                    if (layer.properties.ms !== undefined && greaterMs < parseFloat(layer.properties.ms)) {
                      greaterMs = parseFloat(layer.properties.ms)
                    } 
                    if (layer.properties.ms !== undefined && (lesserMs === null || lesserMs > parseFloat(layer.properties.ms))) {
                      lesserMs = parseFloat(layer.properties.ms)
                    }
                  }
                  const valueDivided = greaterMs / 7
                
                  gradeModule[0] = 0
                  for (let index = 1; index < (6); index++) {
                    if (valueDivided > 50) {
                      gradeModule[index] = Math.round((valueDivided * index)/50)*50
                    } else {
                      let gradeValue = (valueDivided * index).toFixed(1)
                      gradeModule[index] = parseFloat(gradeValue)
                    }
                  }
                  if (valueDivided > 50) {
                    gradeModule.push(Math.floor(greaterMs/50)*50)
                  } else {
                    let gradeValue = greaterMs.toFixed(1)
                    gradeModule.push(parseFloat(gradeValue))
                  }
                  grades = gradeModule
                } else if (type === 'Fibra') {
                  // grades = [0, 20, 30, 40, 50, 60, 70, 80, 90]
                  let greaterFDN = 0
                  let lesserFDN = null
                  for (let index = 0; index < layers.length; index++ ) {
                    let layer = layers[index]
                    if (greaterFDN < parseFloat(layer.properties.fdn)) {
                      greaterFDN = parseFloat(layer.properties.fdn)
                    } 
                    if (lesserFDN === null || lesserFDN > parseFloat(layer.properties.fdn)) {
                      lesserFDN = parseFloat(layer.properties.fdn)
                    }
                  }
                  if (greaterFDN > 0) {
                    greaterFDN = parseFloat(greaterFDN)
                    lesserFDN = parseFloat(lesserFDN)
                    const valueDivided = (greaterFDN - lesserFDN) / 7
                    gradeModule[0] = lesserFDN
                    for (let index = 1; index < (6); index++) {
                      gradeModule[index] = parseFloat((valueDivided * index + lesserFDN).toFixed(0))
                    }
                    gradeModule.push(greaterFDN)
                    grades = gradeModule
                  }
                } else if (type === 'Energia') {
                  // grades = [0, 500, 1000, 1500, 2000, 2500, 3000]

                  let greaterEM = 0
                  let lesserEM = null
                  for (let index = 0; index < layers.length; index++ ) {
                    let layer = layers[index]
                    if (greaterEM < parseFloat(layer.properties.em)) {
                      greaterEM = parseFloat(layer.properties.em)
                    } 
                    if (lesserEM === null || lesserEM > parseFloat(layer.properties.em)) {
                      lesserEM = parseFloat(layer.properties.em)
                    }
                  }
                  if (greaterEM > 0) {
                    const valueDivided = (greaterEM - lesserEM) / 7
                    gradeModule[0] = lesserEM
                    for (let index = 1; index < (6); index++) {
                      gradeModule[index] = parseFloat((valueDivided * index + lesserEM).toFixed(0))
                    }
                    gradeModule.push(greaterEM)
                    grades = gradeModule
                  }

                } else if (type === 'Proteína') {
                  // grades = [0, 2, 4, 6, 8, 10, 11]
                  let greaterPB = 0
                  let lesserPB = null
                  for (let index = 0; index < layers.length; index++ ) {
                    let layer = layers[index]
                    if (greaterPB < parseFloat(layer.properties.pb)) {
                      greaterPB = parseFloat(layer.properties.pb)
                    } 
                    if (lesserPB === null || lesserPB > parseFloat(layer.properties.pb)) {
                      lesserPB = parseFloat(layer.properties.pb)
                    }
                  }
                  if (greaterPB > 0) {
                    const valueDivided = (greaterPB - lesserPB) / 7
                    gradeModule[0] = lesserPB
                    for (let index = 1; index < (6); index++) {
                      gradeModule[index] = parseFloat((valueDivided * index + lesserPB ).toFixed(1))
                    }
                    gradeModule.push(greaterPB)
                    grades = gradeModule
                  }
                } else if (type === 'Imagem Satélite' && filterType === 'NDVI') {
                  grades = [90, 70, 50, 30, 10, 1,'nuvem', 'sombra', 'agua']
                } else if (type === 'Imagem Satélite' && filterType === 'MOISTURE-INDEX') {
                   grades = [0.8, 0.5, 0.24, 0.032, 0, -0.032, -0.24, -0.8]
                } else if (type === 'NDT') {
                  gradeModule[0] = 0
                  gradeModule[1] = 40
                  gradeModule[2] = 45
                  gradeModule[3] = 50
                  gradeModule[4] = 55
                  gradeModule[5] = 60
                  gradeModule[6] = 65
                  grades = gradeModule
                }
              } else {
                if (type === 'Imagem Satélite' && filterType === 'NDVI') {
                  grades = [90, 70, 50, 30, 10, 1,'nuvem', 'sombra', 'agua']
                } else if (type === 'Imagem Satélite' && filterType === 'MOISTURE-INDEX') {
                  grades = [0.8, 0.5, 0.24, 0.032, 0, -0.032, -0.24, -0.8]
                } else {
                  grades = gradeModule
                }
              }
              var div = L.DomUtil.create('div', 'info legend')
              // loop through our density intervals and generate a label with a colored square for each interval
              div.innerHTML += type? type === 'Matéria seca'? type +  ' (kg/ha)' + '<br>' : type === 'Energia'? type + ' (kcal/kg)' + '<br>' : type === 'Proteína'? type + ' (%)' + '<br>'  : type === 'Fibra'? type + ' (%)' + '<br>' : type === 'NDT'? type + '' + '<br>' : (type === 'Imagem Satélite' && filterType === 'NDVI')? 'Condição do pasto' + '<br>' : (type === 'Imagem Satélite' && filterType === 'MOISTURE-INDEX')? 'Teor de Matéria Seca' + '<br>' : '' : ''
              if (type !== 'Imagem Satélite') {
                div.innerHTML +=
                      '<i style="background:' + '#FFFFFF' + '; box-shadow: 0 0 4px rgba(0,0,0,0.2);"></i> ' + 'sem dado'  + '<br>';
              }
              if (grades && grades.length > 0) {
                for (var i = 0; i < grades.length; i++) {
                  div.innerHTML +=
                      type !== 'Imagem Satélite'? '<i style="background:' + getColor(grades[i] + 0.1) + '"></i> ' +
                      grades[i].toLocaleString() + (grades[i + 1] ? '&ndash;' + grades[i + 1].toLocaleString() + (type === 'NDT'? '%' : '') + '<br>' : (type === 'NDT'? '% ' : '') + '+') : '<i style="background:' + getColor(grades[i]) + '"></i> ' + ' '+ gradesLabel[i] + ' ' + '<br>';
                }
              }
              return div;
            };
            info.addTo(mapa);
            legend.addTo(mapa);
          }
          else {
            info.addTo(mapa);
          }
          
        }
        var infoUpdate = true
        function highlightFeature(e) {
          var layer = e.target;
          let code = layer.feature.properties.Name.split('_')
          layer.setStyle({
                weight: 5,
                color: colors[code[0]],
                dashArray: '',
                fillOpacity: 0.7
          });
          layer.bringToFront();
          if(infoUpdate) {
            info.update(layer.feature.properties);
          }
        }
         function resetHighlight(e) {
          geoJson.resetStyle(e.target);
          if(infoUpdate) {
            info.update();
          }
        }
        function lockInfo(e) {
          infoUpdate = false
          var layer = e.target;
          // mapa.fitBounds(e.target.getBounds());
          info.update(layer.feature.properties);
        }
        function textColor(color) {
          let r
          let g
          let b
          let hsp
          color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
          r = color >> 16;
          g = color >> 8 & 255;
          b = color & 255;
          hsp = Math.sqrt( 0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
          if (hsp>127.5) {
            return 'light';
          } 
          else {
            return 'dark';
          }
        }
        function onEachFeature(feature, layer) {
          if (layer && layer.options && layer.options.fillColor) {
            const brightness = textColor(layer.options.fillColor)
            if (brightness === 'light') {
              layer.bindTooltip(layer.feature.properties.Name, {className: 'tooltip-dark',permanent: labelVisibility, direction:"center"}).openTooltip()
            } else {
              layer.bindTooltip(layer.feature.properties.Name, {className: 'tooltip-light',permanent: labelVisibility, direction:"center"}).openTooltip()
            }
          }
          layer.on({
              mouseover: highlightFeature,
              mouseout: resetHighlight,
              click: lockInfo
          });
        }
        let measures = this.measures
        if (this.layers && this.layers.features) {
          for (let index = 0; index< this.layers.features.length; index++) {
            let layerId = this.layers.features[index].properties.id
            if (measures && measures[layerId]) {
              if (measures[layerId].visible_area > 0) {
                this.layers.features[index].properties.ms = parseFloat(((measures[layerId].visible_ms) / (measures[layerId].visible_area)).toFixed(0))
              } else {
                this.layers.features[index].properties.ms = 0
              }
              this.layers.features[index].properties.visibleMS = (measures[layerId].visible_ms / measures[layerId].visible_area * this.layers.features[index].properties.area).toFixed(0)
              if (measures[layerId].fdn) {
                this.layers.features[index].properties.fdn = measures[layerId].fdn.toFixed(1)
              }
              this.layers.features[index].properties.em = measures[layerId].em
              this.layers.features[index].properties.pb = measures[layerId].pb
              if (measures[layerId].ndt) {
                this.layers.features[index].properties.ndt = (measures[layerId].ndt * 100).toFixed(1)
              }
            }
          }
        
          /*let lastZoom = this.lastZoom
          let tooltipThreshold = this.tooltipThreshold
          mapa.on('zoomend', function() {
            var zoom = mapa.getZoom();
            if (zoom < tooltipThreshold && (lastZoom >= tooltipThreshold)) {
                mapa.eachLayer(function(l) {
                    if (l.getTooltip()) {
                        var tooltip = l.getTooltip();
                        l.unbindTooltip().bindTooltip(tooltip, {
                            permanent: false
                        })
                    }
                })
            } else if (zoom >= tooltipThreshold && (lastZoom < tooltipThreshold)) {
                mapa.eachLayer(function(l) {
                    if (l.getTooltip()) {
                        var tooltip = l.getTooltip();
                        l.unbindTooltip().bindTooltip(tooltip, {
                            permanent: true
                        })
                    }
                });
            }
            lastZoom = zoom;
          })
          this.lastZoom = lastZoom */

        }
        geoJson = L.geoJson(this.layers, {
          style: style,
          onEachFeature: onEachFeature,
        }).addTo(this.mapa)
        this.geoJson = geoJson
        if (geoJson) {
          const visibleBounds = geoJson.getBounds();
          this.mapa.fitBounds(visibleBounds, { padding: [10, 10] }); // Ajusta a visão para incluir apenas as geometrias visíveis
        }
      },

      async changeMeasureData() {
        var info = this.info
        var mapa = this.mapa
        if (this.date) {
          let date = []
          if (typeof this.date === 'string') {
            date = this.date.split('-')
            if (!(date[0].length > 2)) {
              this.date = dayjs(date[2]+date[1]+date[0])
            }
          }
          const measureData = await this.$apollo.query({
            query: gql`
              query satellites_data($farm_id: uuid!, $captured_at: timestamptz ) {
                satellites_data(
                  where: {  
                    farm_id: {_eq: $farm_id},
                    captured_at: {_eq: $captured_at},
                    type: {_eq: OPTICO},
                  }, order_by: { created_at: desc },
                ) {
                  paddock_id
                  visible_ms
                  visible_area
                  pb
                  fdn
                  em
                  ndt
                  }
              }
            `,
            variables: {
              farm_id: localStorage.getItem('lastFarm'),
              captured_at: this.date
            },
            fetchPolicy: 'no-cache',
          });
          if (measureData && measureData.data && measureData.data.satellites_data && measureData.data.satellites_data[0]) {
            let measures = measureData.data.satellites_data
            let data = {}
            for (let index = 0; index < measures.length; index++) {
              data[measures[index].paddock_id] = measures[index]
            }
            this.measures = data
          }
          info.remove(mapa)
          if (this.layers && this.layers.features) {
            for (let index = 0; index< this.layers.features.length; index++) {
              let layerId = this.layers.features[index].properties.id
              if (this.measures && this.measures[layerId] && this.measures[layerId].visible_ms) {
                if (this.measures[layerId].visible_area > 0) {
                this.layers.features[index].properties.ms = parseFloat(((this.measures[layerId].visible_ms) / (this.measures[layerId].visible_area)).toFixed(0))
              } else {
                this.layers.features[index].properties.ms = 0
              }
              }
            }
          }
          info.onAdd = function () {
            this._div = L.DomUtil.create('div', 'info'); // create a div with a class "info"
            L.DomUtil.addClass(this._div, 'info')
            this.update();
            return this._div;
          };
          // method that we will use to update the control based on feature properties passed
          info.update = function (props) {
            this._div.innerHTML = (props?
              '<b>Piquete: </b> '+ props.Name +'<br />'+' <b> Área: </b>'+ (props.area? props.area.toLocaleString() + ' ha': '') + '<br/>'
              + ( props.visibleMS? '<b> Matéria Seca no Piquete : </b> ' + props.visibleMS.toLocaleString() + ' kg' + '<br/>' : '') 
              + (props.ms? '<b> Matéria Seca por área : </b> ' +  props.ms.toLocaleString() + ' kg/ha' +'<br/>'  : '') 
              + (props.pb? '<b> Proteína : </b> ' + props.pb.toLocaleString() + '%' +'<br/>' : '') 
              + (props.fdn? '<b> Fibra : </b> ' +  props.fdn.toLocaleString() + '%' + '<br/>' : '') 
              + (props.em? '<b> Energia : </b> ' +  props.em.toLocaleString() + ' kcal/kg' + '<br/>' : '') 
              + (props.ndt? '<b> NDT : </b> ' +  props.ndt.toLocaleString() + '%' + '<br/>' : '')
              : '-');
          };
          info.addTo(mapa);
        }
      },

      async changeMapDate() {
        if (this.sentinelHubLayer && this.sentinelHubLayer.options) {
          this.sentinelHubLayer.options.time = this.limitDate  + '/' + this.measureDate
          this.sentinelHubLayer.wmsParams.time = this.limitDate  + '/' + this.measureDate
          this.sentinelHubLayer.setParams({}, false);
        }
      },

      async changeFarm() {
        const farmID = this.filter.farmId
        var mapa = this.mapa
        var info = this.info
        var geoJson = this.geoJson
        if (farmID !== this.farmID) {
          if (geoJson) {
            mapa.removeLayer(geoJson)
            this.geoJson = null
          }
          info.remove(mapa)
          info.remove()
          mapa.remove()
          this.legend.remove()
          this.mapa = null
          this.info = null
          this.layers = ''
          this.allLayers = ''
          this.layer = ''
          this.legend = ''
          this.farmID = farmID
          this.setupLeafletMap()
        }
      },

      async changeLayer() {

        if (!this.modules.includes('Todos')) {
          const module = await this.$apollo.query({
            query: gql`
              query modules($id: [uuid!] ) {
                modules(
                  where: {  
                    id: {_in: $id},
                    deleted_at: {_is_null: true}
                  }, order_by: { created_at: desc },
                ) {
                  code
                  }
              }
            `,
            variables: {
              id: this.modules,
            },
            fetchPolicy: 'no-cache',
          });
          if (module && module.data && module.data.modules && module.data.modules[0]) {
            let codes = []
            for (let index = 0; index < module.data.modules.length; index++) {
              codes.push(module.data.modules[index].code)
            }
            let greaterMs = 0
            let lesserMs = null
            let greaterFDN = 0
            let lesserFDN = null
            let greaterPB = 0
            let lesserPB = null
            let greaterEM = 0
            let lesserEM = null
            let greaterNDT = 0
            let lesserNDT = null
            const layers = this.allLayers
            let layersArray = []
            for (let index = 0; index < layers.length; index++ ) {
              let layer = layers[index]
              const startsWithCode = codes.some(code => layer.properties.Name.startsWith(code));
              if (startsWithCode) {
                layersArray.push(layer)
                if (greaterMs < parseFloat(layer.properties.ms)) {
                  greaterMs = parseFloat(layer.properties.ms)
                } 
                if (lesserMs === null || lesserMs > parseFloat(layer.properties.ms)) {
                  lesserMs = parseFloat(layer.properties.ms)
                }
                if (greaterFDN < parseFloat(layer.properties.fdn)) {
                  greaterFDN = parseFloat(layer.properties.fdn)
                } 
                if (lesserFDN === null || lesserFDN > parseFloat(layer.properties.fdn)) {
                  lesserFDN = parseFloat(layer.properties.fdn)
                }
                if (greaterPB < parseFloat(layer.properties.pb)) {
                  greaterPB = parseFloat(layer.properties.pb)
                } 
                if (lesserPB === null || lesserPB > parseFloat(layer.properties.pb)) {
                  lesserPB = parseFloat(layer.properties.pb)
                }
                if (greaterEM < parseFloat(layer.properties.em)) {
                  greaterEM = parseFloat(layer.properties.em)
                } 
                if (lesserEM === null || lesserEM > parseFloat(layer.properties.em)) {
                  lesserEM = parseFloat(layer.properties.em)
                }
                if (greaterNDT < parseFloat(layer.properties.ndt)) {
                  greaterNDT = parseFloat(layer.properties.ndt)
                } 
                if (lesserNDT === null || lesserNDT > parseFloat(layer.properties.ndt)) {
                  lesserNDT = parseFloat(layer.properties.ndt)
                }
              }
            }
            this.rangeMS[0] = greaterMs
            this.rangeMS[1] = lesserMs
            this.rangeFDN[0] = greaterFDN
            this.rangeFDN[1] = lesserFDN
            this.rangePB[0] = greaterPB
            this.rangePB[1] = lesserPB
            this.rangeEM[0] = greaterEM
            this.rangeEM[1] = lesserEM
            this.rangeNDT[0] = greaterNDT
            this.rangeNDT[1] = lesserNDT
            this.layers.features = layersArray
          }
        } else {
          this.layers.features = this.allLayers
        }
      },

      async alterLabelVisibility () {
        const mapa = this.mapa
        if (this.filter.label) {
          mapa.eachLayer(function(l) {
            if (l.getTooltip()) {
              var tooltip = l.getTooltip();
              l.unbindTooltip().bindTooltip(tooltip, {
                  permanent: true
              })
            }
          })
        } else {
          mapa.eachLayer(function(l) {
            if (l.getTooltip()) {
              var tooltip = l.getTooltip();
              l.unbindTooltip().bindTooltip(tooltip, {
                  permanent: false
              })
            }
          })
        }
      },

      async changeMapFilter() {
        if (this.sentinelHubLayer && this.sentinelHubLayer.options) {
            this.sentinelHubLayer.options.preset = this.imageFilter;  
            this.sentinelHubLayer.options.layers = this.imageFilter;
            this.sentinelHubLayer.wmsParams.preset = this.imageFilter;
            this.sentinelHubLayer.wmsParams.layers = this.imageFilter;
            this.sentinelHubLayer.options.gain = this.gain;
            this.sentinelHubLayer.wmsParams.gain = this.gain;
            this.sentinelHubLayer.options.gama = this.gama; 
            this.sentinelHubLayer.wmsParams.gama = this.gama;
            this.sentinelHubLayer.setParams({}, false);
        }
     },

     async changeMapGain() {
        if (this.sentinelHubLayer && this.sentinelHubLayer.options) {
            this.sentinelHubLayer.options.gain = this.gain;
            this.sentinelHubLayer.wmsParams.gain = this.gain;
            this.sentinelHubLayer.setParams({}, false);
        }
      },

      async changeMapGama() {
        if (this.sentinelHubLayer && this.sentinelHubLayer.options) {
            this.sentinelHubLayer.options.gama = this.gama; 
            this.sentinelHubLayer.wmsParams.gama = this.gama;  
            this.sentinelHubLayer.setParams({}, false); 
        }
      },

      async print() {
        this.loaded = false
        const zoom = this.mapa.getZoom();
        this.mapa.setZoom(zoom - 0.4);
        await new Promise((resolve) => {
          this.mapa.once('zoomend', resolve); // Aguarda o evento 'zoomend'
        });
        await this.delay(this.delayValue)
        this.delayValue = 5000
        const el = this.$refs.mapa;
        const gElement = el.querySelector('g');
        const legendElement = document.querySelector('.legend');
        const logoElement = document.querySelector('.logo');
        const attributionElement = document.querySelector('.leaflet-control-attribution');
        // const infoElement = document.querySelector('.info');
        const zoomElement = document.querySelector('.leaflet-control-zoom');
        const fullscreenElement = document.querySelector('.leaflet-control-zoom-fullscreen')

        attributionElement.style.visibility = 'hidden';
        zoomElement.style.visibility = 'hidden';
        fullscreenElement.style.visibility = 'hidden';

        // Obter as dimensões do bounding box da tag <g>
        const boundingBox = gElement.getBoundingClientRect();
        const mapWidth = boundingBox.width;
        const mapHeight = boundingBox.height;

        // Obter as dimensões da legenda e do logo
        let legendHeight = null;
        let legendWidth = null;
        if (legendElement) {
          legendWidth = legendElement.clientWidth;
          legendHeight = legendElement.clientHeight;
        }
        const padding = 0;

        // Criar um canvas maior para incluir logo e legenda
        const canvasWidth = mapWidth; // Mantém a largura original
        let canvasHeight = null;
        if (legendWidth) {
          canvasHeight = mapHeight + legendHeight + padding; // Adiciona altura para legenda abaixo
        } else {
          canvasHeight = mapHeight + padding;
        }

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        try {
          // Capturar as imagens do mapa, logo e legenda em paralelo
          const [mapCanvas, logoCanvas, legendCanvas] = await Promise.all([
            this.$html2canvas(el, {
              useCORS: true,
              width: mapWidth,
              height: mapHeight,
              x: boundingBox.left,
              y: boundingBox.top,
              windowWidth: document.documentElement.clientWidth,
              windowHeight: document.documentElement.clientHeight,
            }).then(canvas => canvas.toDataURL()),
            this.$html2canvas(logoElement, { useCORS: true, backgroundColor: null }).then(canvas => canvas.toDataURL()),
            legendElement ? this.$html2canvas(legendElement, { useCORS: true }).then(canvas => canvas.toDataURL()) : null,
          ]);

          // Desenhar o mapa no canvas
          const mapImg = await this.loadImageWithDelay(mapCanvas);
          context.drawImage(mapImg, 0, 0, mapWidth, mapHeight);

          // Desenhar o logo no canvas
          const logoImg = await this.loadImage(logoCanvas);

          const paddingLogo = 0; // margem da borda
          // Pega a menor dimensão entre largura e altura do mapa
          const menorDimensao = Math.min(mapWidth, mapHeight);

          // Define a logo para ocupar no máximo 15% da menor dimensão
          const maxLogoWidth = menorDimensao * 0.3;
          const scale = maxLogoWidth / logoImg.width;
          const scaledLogoWidth = logoImg.width * scale;
          const scaledLogoHeight = logoImg.height * scale;

          // desenha a logo redimensionada no canto superior esquerdo
          context.drawImage(logoImg, paddingLogo, paddingLogo, scaledLogoWidth, scaledLogoHeight);

          // Se houver legenda, desenhe-a no canvas
          if (legendElement) {
            const legendImg = await this.loadImage(legendCanvas);
            context.drawImage(
              legendImg,
              canvasWidth - legendWidth - padding, // Alinhado à direita
              mapHeight + padding, // Abaixo do mapa
              legendWidth,
              legendHeight
            );
          }

          // Gerar o download
          const finalImage = canvas.toDataURL('image/png');
          const link = document.createElement('a');
          link.href = finalImage;
          link.download = 'imagem.png';
          document.body.appendChild(link); // Adiciona o link no DOM
          link.click(); // Executa o clique no link para download
          document.body.removeChild(link) // Remove o link do DOM após o download
          this.loaded = true
        } catch (error) {
          console.error("Erro ao gerar imagem:", error);
          this.loaded = true
        } finally {
          // Restaurar a visibilidade dos elementos
          attributionElement.style.visibility = 'visible';
          zoomElement.style.visibility = 'visible';
          fullscreenElement.style.visibility = 'visible';
          this.mapa.setZoom(zoom);
        }
      },

      // Função para carregar imagens de forma assíncrona
      loadImage(src) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'Anonymous'; // Habilita CORS para carregar a imagem de um domínio externo
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = src;
        });
      },

      async loadImageWithDelay(src) {
        await this.delay(200); // Aguarda o tempo especificado
        return this.loadImage(src); // Carrega a imagem
      },

      delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }

    }
  }
</script>

<template>
  <div>
    <filter-map :class="$vuetify.breakpoint.xs? 'no-print' : $vuetify.breakpoint.sm? 'no-print' : 'filter no-print'"/>
    <div id="mapa" ref="mapa">
      <v-col v-if="showPrint" cols="12" sm="12" align="right" data-html2canvas-ignore="true">
        <v-btn class="button-map" @click="print">Salvar</v-btn>
      </v-col>
      <v-progress-circular
        v-if="!loaded"
        class="loading"
        color="primary"
        :value="loadProgress"
        :size="80"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<style>
  #mapa {
    height: 72.5vh;
    width: 100%;
    z-index: 1;
  }
  .button-map {
    background-color: rgba(0,0,0,0) !important;
    box-shadow: none !important;
    text-align: end;
    z-index: 1001;
  }
  .v-application .info {
    background-color: white !important;
    border-color: white !important;
  }
  .info {
    padding: 6px 8px;
    font: 14px/16px Arial, Helvetica, sans-serif;
    background: white;
    background: rgba(255,255,255,0.8);
    box-shadow: 0 0 15px rgba(0,0,0,0.2);
    border-radius: 5px;
  }
  .info h4 {
      margin: 0 0 5px;
      color: #777;
  }
  .legend {
    line-height: 18px;
    color: #555;
    background: white;
}
  .legend i {
    width: 18px;
    height: 18px;
    float: left;
    margin-right: 8px;
    opacity: 1;
}
.tooltip-dark {
  font-size: 8px;
  background-color: rgba(0,0,0,0) !important;
  border:none;
  box-shadow: none;
}
.tooltip-light {
  font-size: 8px;
  color: white;
  background-color: rgba(0,0,0,0) !important;
  border:none;
  box-shadow: none;
}
.leaflet-control-layers {
  visibility: collapse;
}

.leaflet-bar a {
  background-color: transparent !important;
  border-bottom: none !important;
}
.leaflet-bar a:hover {
  background-color: rgba(255, 255, 255, 0.7) !important;
  border-bottom: 2px solid #fff !important;
}
.leaflet-touch .leaflet-bar, .leaflet-touch .leaflet-control-layers {
  border: none !important;
}
.leaflet-control-container .leaflet-top.leaflet-right {
  top: 10%;
}
.leaflet-control-layers {
  display: none !important
}
.loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1002;
  }
</style>